import DashboardSideMenu from '@c/dashboard/DashboardSideMenu';
import MobileSidebar from '@c/dashboard/MobileSidebar';
import BaseDrawer from '@c/drawers/BaseDrawer';
import ProfileItem from '@c/ProfileItem';
import Button from '@ui/Button';
import { useAuth } from 'context/AuthContext';
import { XIcon } from 'lucide-react';

interface MenuDrawer {
  show: boolean;
  dismiss: () => void;
}

const MenuDrawer = ({ show, dismiss }: MenuDrawer) => {
  const { user, userDoc } = useAuth();

  return (
    <div className="min-w-[100vw]">
      <div className="overflow-y-scroll">
        <BaseDrawer
          show={show}
          dismiss={() => {
            dismiss();
          }}
        >
          <div className="h-full w-full">
            <MobileSidebar dismiss={dismiss} />
          </div>
        </BaseDrawer>
      </div>
    </div>
  );
};

export default MenuDrawer;
